import { useState } from 'react';
import { startOfToday, format } from 'date-fns';
import Calendar from 'components/calendar';
import { FORMAT_QT_DATE } from 'utils/helpers/datetime';

const AvailabilitySearch = () => {
  const [date, setDate] = useState(startOfToday());

  const dispatchDate = (value) => {
    const inputs = document.querySelectorAll(
      '.availability-quick-view__hidden-input'
    );
    inputs.forEach((input) => {
      input.value = format(value, FORMAT_QT_DATE);
      input.dispatchEvent(new Event('change'));
    });
  };

  return (
    <div className="quick-view-search d-flex justify-content-end">
      <div className="quick-view-search__label me-3">Availability search:</div>
      <div className="input-with-icon">
        <div className="input-with-icon__icon input-with-icon__icon--left primary">
          <i className="far fa-calendar-alt" />
        </div>
        <Calendar
          value={date}
          inputProps={{
            readOnly: true,
            'aria-label': 'search-calendar',
          }}
          onChange={({ value }) => {
            if (value) {
              setDate(value);
              dispatchDate(value);
              // setFieldValue('date', formatDate(value));
            }
          }}
        />
        <div className="input-with-icon__icon">
          <i className="fas fa-chevron-down" />
        </div>
      </div>
    </div>
  );
};

export default AvailabilitySearch;
